/**
 * Polyfills for modern JavaScript features to support older environments
 * and tools like react-snap.
 */

// Polyfill for Object.hasOwn (ES2022)
if (typeof (Object as any).hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: function(object: any, property: PropertyKey) {
      if (object === null || object === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      return Object.prototype.hasOwnProperty.call(Object(object), property);
    },
    configurable: true,
    enumerable: false,
    writable: true
  });
}

// Export empty to satisfy module requirement if needed
export {};
